import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import "./dropDown.css";

const BookingSourceDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "failed", label: "Failed" },
  ];

  const selectedOption = options.find((opt) => {
    if (typeof opt.value === 'string' && typeof value === 'string') {
      return opt.value === value;
    }

    if (Array.isArray(opt.value) && Array.isArray(value)) {
      return JSON.stringify(opt.value) === JSON.stringify(value);
    }
    return false;
  });

  const handleSelect = (optionValue) => {
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className="booking-dropdown-wrapper">
      <button
        className="dropdown-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <span className="dropdown-icon">{selectedOption?.icon}</span>
        <span className="dropdown-label">{selectedOption?.label}</span>
        <ChevronDown
          size={18}
          className={`dropdown-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option) => (
            <button
              key={option.value}
              className={`dropdown-option ${value === option.value ? "active" : ""
                }`}
              onClick={() => handleSelect(option.value)}
            >
              <span className="option-label">{option.label}</span>
              {value === option.value && (
                <span className="checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookingSourceDropdown;